import {CustomModal} from "../../modules/CustomModal";
import {OfferSwitcher} from "../Card/OfferSwitcherAB";
import {Product} from "./Product";

export class Add {
    constructor(id, callback = null, preloader = true) {
        if (preloader === true) $('body').preloader('show'); else if (preloader !== false) preloader.addClass('btn-progress').prop('disabled', true);

        this.callback = callback;
        this.preloader = preloader;

        this.process(id);
    }
    process(id) {
        $.post('/ajax/basket/add/', {id: id}, (result) => {
            if (!result.hasOwnProperty('type')) {
                console.error(result);
                return;
            }

            try {
                if (result.type == 'success') {
                    this.handleSuccess(id, result);
                } else if (result.type === 'error') {
                    this.handleError(id, result);
                }
            } catch(e) {
                console.error(e);
            }

        }, 'json');
    }

    handleSuccess(id, result)
    {
        window._store.dispatch(window._ActionCreators.addItemToBasket(parseInt(id)));

        const product = Product.findById(id);
        BX.Event.EventEmitter.emit('Mario.Basket:added', { product });

        window.dataLayer.push({
            'ecomm_event': 'cart_add',
            'total_value': product.price,
            'product_ids': product.id
        });

        if ('APRT_SEND' in window) {
            window.APRT_SEND({
                pageType: 8,
                currentProduct: {
                    id: product.id,
                    name: product.name,
                    price: product.price
                }
            });
        }

        try {
            rrApi.addToBasket(id)
        } catch(e) {}

        if ('DSPCounterExt' in window) {
            DSPCounterExt('send',{
                'site_area': 'w1YldxWF',
                'lead_id': product.id,
                'order_sum': product.price
            });
        }

        const offersBlock = $('.js-offer-switcher');
        // refreshHeaderBasket();
        refreshOffersArray(id, 'add', offersBlock.data('product'));
        offersBlock.bindToEntity(OfferSwitcher);

        if (this.preloader !== true && this.preloader !== false) {
            this.preloader.removeClass('btn-progress').prop('disabled', false);
        }

        if (this.callback) {
            this.callback();
        }
    }

    handleError(id, result)
    {
        const shownModal = $('.modal.in');
        console.error(result.value);

        if (shownModal && shownModal.length > 0) {
            shownModal.modal('hide');
        }

        let modal = new CustomModal();
        modal.show('Во время добавления произошла ошибка', result.value);

        if (this.preloader === true) {
            $('body').preloader('hide'); 
        } else if (this.preloader !== false) {
            this.preloader.removeClass('btn-progress').prop('disabled', false);
        }
    }
}
